import { Helmet } from 'react-helmet';
import {
  Box,
  Container,
} from '@mui/material';

import RecruiterScans from "../components/scans/RecruiterScans"
import CandidatScans from "../components/scans/CandidatScans"

import { getCurrentUser } from "../utils/auth"

const Scans = () => {
  let accountType = getCurrentUser()?.type
  return (
    <>
      <Helmet>
        <title>Scans | TheScan</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'white',
          minHeight: '100%',
          py: 0,
          display:"flex",
          flexDirection:"column",
        }}
      >
        {accountType === "theScanRecruiter" &&
          <RecruiterScans/>
        }
        {accountType === "theScanCandidat" &&
          <CandidatScans/>
        }
      </Box>
    </>
  )
};

export default Scans;
